<template>
<div class="chapter">
<div class="inner_page">
<p class="pn" id="part1"><a id="p5"></a>PART ONE</p>
<p class="pt">E PLURIBUS INC.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part_01.vue?6b8e410c